import { useEffect, useState } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { keyframes } from 'style'

import useLocalStorage from 'hooks/use-local-storage'

import Box from 'components/atomic/atoms/box'
import Text from 'components/atomic/atoms/text'

const animationOff = keyframes({
  from: {
    height: 34,
    transform: 'translateY(0)',
  },
  to: {
    height: 0,
    transform: 'translateY(-38px)',
  },
})

const cta =
  '🚀 Simplify building realtime applications with GraphQL Live Queries 🚀'
const blogPath =
  '/blog/simplify-building-realtime-applications-with-graphql-live-queries'

let hasBeenAlreadyMounted = false

const AnnouncementBanner = () => {
  const { asPath } = useRouter()
  const [showCloseAnimation, setShowCloseAnimation] = useState(false)
  const [hidden, setHidden] = useLocalStorage<boolean>(cta, true)
  const [mounted, setMounted] = useState(hasBeenAlreadyMounted)

  const onClose = () => {
    setShowCloseAnimation(true)
    setTimeout(() => setHidden(true), 500)
  }

  useEffect(() => {
    // As the layout is mounted and unmounted we need to persist the state of this
    setMounted(true)
    hasBeenAlreadyMounted = true
  }, [])

  const isSamePath = asPath === blogPath

  if (hidden || !mounted || isSamePath) {
    return null
  }

  return (
    <Box
      css={{
        bgc: '$accent',
        willChange: 'height',
        '@md': {
          animation: showCloseAnimation
            ? `${animationOff} 500ms forwards`
            : `none`,
        },
      }}
    >
      <Box
        flex={{ '@initial': 'column', '@md': true }}
        items="center"
        justify="center"
        css={{
          py: 7,
          px: '$4',
          '@md': {
            spaceX: 1,
            px: 0,
          },
        }}
      >
        <Text
          size={{ '@initial': 'xs', '@md': 'sm' }}
          color="textAccent"
          weight="bold"
          align="center"
        >
          {cta}
        </Text>
        <Text
          size={{ '@initial': 'xs', '@md': 'sm' }}
          weight="medium"
          color="textAccent"
        >
          Read the{' '}
          <Text as={Link} href={blogPath} weight="bold" underline>
            blog post
          </Text>
          .{' '}
          <Text
            as="button"
            size={{ '@initial': 'xs', '@md': 'sm' }}
            onClick={onClose}
            underline
          >
            Dismiss
          </Text>
        </Text>
      </Box>
    </Box>
  )
}

export default AnnouncementBanner
